import React from "react";
import Project from '../../api/project'
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'swiper/css';
import 'swiper/css/pagination';
import { Fade } from "react-awesome-reveal";
import icon from '../../images/icon/eye-icon.svg'

const ProjectSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const mainSliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        adaptiveHeight: true,
        centerMode: true,
        useTransform: true,
        centerPadding: "300px",
        cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: true,
        // white hollow dots
        customPaging: () => (
            <div className="w-4 h-4 rounded-full border-2 border-white bg-transparent" />
        ),
        // bottom center placement
        appendDots: (dots) => (
            <div className="absolute bottom-6 w-full flex justify-center">
                <ul className="flex gap-3 m-0 p-0">{dots}</ul>
            </div>
        ),
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerPadding: "150px",
                },
            },
            {
                breakpoint: 640,
                settings: {
                    centerPadding: "100px",
                },
            },
            {
                breakpoint: 420,
                settings: {
                    centerPadding: "20px",
                },
            },
        ],
    };

    return (
        <section className="project o-hidden pb-140">
            <div className="container">
                <div className="sa-project-top ul_li_between mb-25">
                    <div className="sec-title--two mb-30">
                        <Fade direction='up' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <span className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                    <img src={icon} alt="" />
                                    Our Odoo & E-commerce case studies
                                </span>
                            </div>
                        </Fade>
                        <Fade direction='up' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <h2 className="title wow skewIn" data-wow-duration="600ms">
                                    Recent Odoo, Manufacturing & E-commerce projects
                                </h2>
                                <p className="mt-15 text-white/70">
                                    We help businesses with Odoo integration, manufacturing & inventory flows,
                                    complete Odoo + React Native app development, and end-to-end e-commerce
                                    solutions on Shopify & Magento.
                                </p>
                            </div>
                        </Fade>
                    </div>
                    <div className="xb-btn text-center wow fadeInRight mb-30" data-wow-duration="600ms">
                        <Fade direction='right' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <Link
                                    onClick={ClickHandler}
                                    to={'/casestudy'}
                                    className="thm-btn thm-btn--aso"
                                >
                                    View all case studies
                                </Link>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>

            <div className="sa-project_wrapper">
                <div className="seo-project-slider-inner">
                    <div className="seo-project-slider">
                        <Slider {...mainSliderSettings} className="seo-project-slider">
                            {Project.slice(0, 9).map((project, prj) => (
                                <div className="sa-project-item-wrap" key={prj}>
                                    <div
                                        className="sa-project-item bg_img"
                                        style={{ backgroundImage: `url(${project.pImg})` }}
                                    >
                                        <div className="xb-item--inner ul_li_between pos-rel z-1">
                                            <div className="xb-item--project_title">
                                                <h2 className="xb-item--title">{project.title}</h2>
                                                <p className="xb-item--content">{project.description}</p>
                                                <div className="xb-btn mt-50">
                                                    <Link
                                                        onClick={ClickHandler}
                                                        to={`/portfolio_details/${project.slug}`}
                                                        className="thm-btn thm-btn--border"
                                                    >
                                                        View project details
                                                        <span>
                                                            <svg
                                                                width="11"
                                                                height="11"
                                                                viewBox="0 0 11 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M10.7354 3.14709C10.8167 2.74092 10.5533 2.3458 10.1471 2.26456L3.52817 0.94078C3.122 0.859546 2.72688 1.12296 2.64565 1.52913C2.56441 1.9353 2.82782 2.33042 3.23399 2.41165L9.11748 3.58835L7.94078 9.47183C7.85955 9.878 8.12296 10.2731 8.52913 10.3544C8.9353 10.4356 9.33042 10.1722 9.41165 9.76601L10.7354 3.14709ZM1.41603 9.62404L10.416 3.62404L9.58398 2.37596L0.583975 8.37596L1.41603 9.62404Z"
                                                                    fill="#0C111D"
                                                                />
                                                            </svg>
                                                        </span>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="xb-item--item-box mt-none-50">
                                                <div className="xb-item--item">
                                                    <span className="xb-item--number">{project.rnumber}%</span>
                                                    <span className="xb-item--text">{project.rtext}</span>
                                                </div>
                                                <div className="xb-item--item border-blue">
                                                    <span className="xb-item--number">${project.tnumber}k</span>
                                                    <span className="xb-item--text">{project.ttext}</span>
                                                </div>
                                                <div className="xb-item--item border-sky">
                                                    <span className="xb-item--number">{project.snumber}%</span>
                                                    <span className="xb-item--text">{project.stext}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>

            {/* make active dot blue + remove default slick dot */}
            <style>{`
                .slick-dots li button {
                    padding: 0;
                }
                .slick-dots li button:before {
                    content: '' !important;
                }
                .slick-dots li.slick-active div {
                    background-color: #0F55DC !important;
                    border-color: #0F55DC !important;
                }
            `}</style>
        </section>
    );
}

export default ProjectSection;
